// src/components/layouts/admindashboard/sidebar/index.tsx

import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import SidebarHeader from "./sub/SidebarHeader";
import MenuItem from "./sub/MenuItem";
import AdminTourComponent from "../../../tour/AdminTourLoader";
import { useMobileMenu } from "../../../../context/MobileMenuContext";

const menuSections = [
  {
    title: "Principale",
    items: [
      { name: "Dashboard", icon: "LayoutDashboard", path: "/admin/dashboard/home", tourId: "menu-dashboard" },
    ],
  },
  {
    title: "Boutique",
    items: [
      { name: "Catégories produits", icon: "FolderTree", path: "/admin/dashboard/product-categories", tourId: "menu-product-categories" },
      { name: "Produits", icon: "Package", path: "/admin/dashboard/products", tourId: "menu-products" },
       {
        name: "Commandes",
        icon: "ShoppingCart",
        path: "/admin/dashboard/commerces/orders",
      },
      {
        name: "Produits vendus",
        icon: "PackageCheck",
        path: "/admin/dashboard/commerces/product-stats",
      },
      {
        name: "Clients",
        icon: "Users",
        path: "/admin/dashboard/commerces/customers",
      },
    ],
  },
  {
    title: "Blog & Conseils",
    items: [
      { name: "Articles", icon: "FileText", path: "/admin/dashboard/articles", tourId: "menu-articles" }, // corrigé
      { name: "Catégories d'articles", icon: "FolderOpen", path: "/admin/dashboard/article-categories", tourId: "menu-article-categories" },
      // { name: "Commentaires", icon: "MessageCircle", path: "/admin/dashboard/comments" },
    ],
  },
  {
    title: "Offres & Services",
    items: [
      { name: "Services", icon: "Briefcase", path: "/admin/dashboard/services", tourId: "menu-services" },
    ],
  },


  {
    title: "Finances",
    items: [
      { name: "Transactions", icon: "ArrowLeftRight", path: "/admin/dashboard/finances/transactions" },
      { name: "Relevés", icon: "BarChart3", path: "/admin/dashboard/finances/reports" },
    ],
  },

  {
    title: "Administration",
    items: [
      { name: "Utilisateurs", icon: "UserCog", path: "/admin/dashboard/users", tourId: "menu-users" },
      { name: "Notifications", icon: "Bell", path: "/admin/dashboard/admin-notifications", tourId: "menu-notifications" },
      { name: "Paramètres généraux", icon: "Settings", path: "/admin/dashboard/settings", tourId: "menu-settings" },
    ],
  },
  {
    title: "Compte",
    items: [
      { name: "Profil", icon: "User", path: "/admin/dashboard/profile", tourId: "menu-profile" },
      { name: "Sécurité", icon: "Shield", path: "/admin/dashboard/security", tourId: "menu-security" },
      { name: "Préférences", icon: "BellRing", path: "/admin/dashboard/preferences", tourId: "menu-preferences" },
    ],
  },
];

const Sidebar: React.FC = () => {
  const { isOpen: isMobileOpen, close: onMobileClose } = useMobileMenu();

  return (
    <>

      <AdminTourComponent />
      <AnimatePresence>
        {isMobileOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onMobileClose}
            className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden"
          />
        )}
      </AnimatePresence>
      <aside
        className={`
          fixed top-0 left-0 z-50 h-full w-[280px] 
          bg-gradient-to-b from-green-900 to-green-900
          backdrop-blur-sm
          border-r border-accent/20
          shadow-2xl shadow-black/20
          transition-transform duration-300 ease-in-out
          ${isMobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="flex flex-col h-full relative">
          {/* Effet de lumière en haut */}
          <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-accent/5 to-transparent pointer-events-none" />

          <SidebarHeader />

          <nav className="flex-1 overflow-y-auto persosrcollbar px-3 py-6 scrollbar-thin scrollbar-thumb-accent/30 scrollbar-track-transparent">
            {menuSections.map((section, idx) => (
              <div key={idx} className="mb-6">
                <h3 className="text-[11px] font-bold uppercase tracking-wider text-accent/70 mb-2 ml-2">
                  {section.title}
                </h3>
                <div className="space-y-1">
                  {section.items.map((item) => (
                    <MenuItem
                      key={item.name}
                      item={item}
                      onMobileClose={onMobileClose}
                    />
                  ))}
                </div>
              </div>
            ))}
          </nav>

          <div className="p-4 border-t border-accent/20 text-start">
            <p className="text-[10px] text-white/70">🌿  L'efficacité des Psaumes et Plantes – v1.0</p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;